module.exports = __webpack_public_path__ + "static/benefits-img1-4990a98b853b1bff45b63d71fefd3301.png";